module.exports = __webpack_public_path__ + "static/media/KaTeX_Main-Italic.bb7c45db.woff";